<template>
    <div id="container">
        <v-container>
            <v-layout
                    wrap
            >
                <v-flex v-for="(provider, i) in providers" :key="i" xs4 :pa-5="!$vuetify.breakpoint.smAndDown" :pa-2="$vuetify.breakpoint.smAndDown">
                    <v-img :src="require('@/assets/anbieter/' + provider)" height="50px" contain/>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
  export default {
    data: () => ({
      providers: [
        'o2-logo.png',
        'telekom-logo.png',
        'vodafone-logo.png',
      ]
    })
  }
</script>

<style lang="scss" scoped>
    #container {
        background: rgb(122,188,255);
        background: -moz-linear-gradient(left, rgba(122,188,255,1) 0%, rgba(170,212,255,1) 100%);
        background: -webkit-linear-gradient(left, rgba(122,188,255,1) 0%,rgba(170,212,255,1) 100%);
        background: linear-gradient(to right, rgba(122,188,255,1) 0%,rgba(170,212,255,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7abcff', endColorstr='#aad4ff',GradientType=1 );
    }
</style>
